import { upperCase } from 'lodash'
import moment from 'moment'

import { formatSecondsToHM } from 'modules/core/lib/formatTime'

import type UnassignedShift from 'modules/shift_management/store/internal/models/UnassignedShift'

export interface Props {
  unassignedShifts: UnassignedShift[]
}

const useCalculateSummaryUnassignedShifts = ({ unassignedShifts }: Props) => {
  let totalCounters = 0
  let totalSeconds = 0
  unassignedShifts.map((unassignedShift) => {
    totalCounters += unassignedShift.counter
    const datesDuration = moment.duration(unassignedShift.endAt.diff(unassignedShift.startAt))
    totalSeconds +=
      unassignedShift.counter *
      (Math.floor(datesDuration.asHours()) * 3600 + datesDuration.minutes() * 60)
  })

  const totalTime = upperCase(formatSecondsToHM(totalSeconds))

  return {
    totalCounters,
    totalTime,
  }
}
export { useCalculateSummaryUnassignedShifts }
